import React, {useRef, useState} from 'react';

const UsePopUpHooks = ({itemName}) => {
    const [visible, setVisible] = useState(true);
    const ref = useRef(null);

/*
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref?.current?.contains(event.target)) {
                setVisible(false)
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

*/

    const onClickDisableWeek = () => {
        const nowTime = new Date(Date.now());
        const nextDay = new Date(nowTime.getFullYear(),nowTime.getMonth(),nowTime.getDate() + 1);
        localStorage.setItem(itemName, nextDay.getTime().toString())
        setVisible(false)
    }

    const onClickClose = () => {
        setVisible(false)
    }

    return {
        visible, ref, onClickDisableWeek,onClickClose
    }
};

export default UsePopUpHooks;